module.exports = __webpack_public_path__ + "static/media/Avenir-Light.32c4d0db.otf";